class ComponentMarquee extends Theme.Component {
  #items = [];
  #resize_observer = null;

  connectedCallback() {
    super.connectedCallback();

    if (!this.elements.track) {
      return;
    }

    this.#items = Array.from(this.elements.track.children).filter((item) => !item.dataset.clone);

    requestAnimationFrame(() => {
      this.refresh();
      this.classList.add("state--ready");
    });

    this.#resize_observer = new ResizeObserver(Theme.Helpers.debounce(this.refresh.bind(this), 150));
    this.#resize_observer.observe(this);

    document.fonts?.ready.then(() => this.refresh());
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#resize_observer?.disconnect();
    this.#resize_observer = null;
  }

  togglePause(detail, element) {
    const paused = this.classList.toggle("state--paused");

    element.setAttribute("aria-pressed", paused ? "true" : "false");
  }

  get speed() {
    return Math.max(parseFloat(this.dataset.speed) || 60, 1);
  }

  refresh() {
    const track = this.elements.track;

    if (!track || this.#items.length === 0) {
      return;
    }

    this.removeClones(track);

    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const shift = track.getBoundingClientRect().width + gap;

    if (shift <= 0) {
      return;
    }

    const target = this.offsetWidth + shift;

    for (let width = shift; width < target; width += shift) {
      this.#items.forEach((item) => track.appendChild(this.buildClone(item)));
    }

    this.style.setProperty("--shift", `${shift}px`);
    this.style.setProperty("--duration", `${shift / this.speed}s`);
  }

  buildClone(item) {
    const clone = item.cloneNode(true);

    clone.setAttribute("aria-hidden", "true");
    clone.dataset.clone = "true";

    Array.from(clone.attributes).forEach((attribute) => {
      if (attribute.name.startsWith("data-shopify")) {
        clone.removeAttribute(attribute.name);
      }
    });

    return clone;
  }

  removeClones(track) {
    track.querySelectorAll(":scope > [data-clone]").forEach((clone) => clone.remove());
  }
}

customElements.define("component-marquee", ComponentMarquee);
